var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_jjWrap"},[_c('div',{ref:"myHtml",staticClass:"_html",domProps:{"innerHTML":_vm._s(_vm.contentJj)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }